import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=8054626a&scoped=true"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8054626a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8054626a')) {
      api.createRecord('8054626a', component.options)
    } else {
      api.reload('8054626a', component.options)
    }
    module.hot.accept("./tab-item.vue?vue&type=template&id=8054626a&scoped=true", function () {
      api.rerender('8054626a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/container-item/tab-item.vue"
export default component.exports